import { IRouteChild } from '@simac/ui';
import { OutboundMoveAssetRoute } from './move-asset/move-asset.routes';
import { OutboundMovePalletRoute } from './move-pallet/move-pallet.routes';

export const OutboundRoute: IRouteChild[] = [
  {
    title: 'MENU.FIELDSUPPORT.MOVE-ASSET',
    icon: 'far fa-gem',
    route: OutboundMoveAssetRoute,
  },
  {
    title: 'MENU.FIELDSUPPORT.MOVE-PALLET',
    icon: 'far fa-pallet-box',
    route: OutboundMovePalletRoute,
  },
];
